<template>

    <div class="bg-white border-b border-gray-100 ">
      <!-- Primary Navigation Menu -->
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ">
        <div class="flex justify-between ">
          <div class="flex">
            <!-- Navigation Links -->
           
              <!-- <slot></slot> -->
                <jet-nav-link
          class="space-x-8"
                    :href="route('tc-integrates.index')"
                    :active="route().current('tc-integrates.index')"
                >
                    Excel
                </jet-nav-link>
             

               <jet-nav-link
                    class="ml-12 space-x-8"
                    :href="route('tc-templates.index')"
                    :active="route().current('tc-templates.index')"
                >
                    Template
                </jet-nav-link>

                    <jet-nav-link
                    class="ml-12 space-x-8"
                    :href="route('tc-configurations.index')"
                    :active="route().current('tc-configurations.index')"
                >
                    Settings
                </jet-nav-link>
            </div>
            <!-- templates -->
            <!-- Settings -->    
          
           <div class="frm" >
              <!-- <span>Tally:</span> -->
                <btn type="button" class="curve-stroke d-flex">
                    <span>
                        <!-- <i class="fa fa-times tally_not_open" aria-hidden="true" ></i> -->
                        <img v-show="tally_open_status=='false'" :src="'/imgs/tallycross3.png'" alt=""  aria-hidden="true" height="30" width="30" style="margin-top:5px">
                        <img v-show="tally_open_status=='true'" :src="'/imgs/tallycolor.png'" alt="" aria-hidden="true"  height="30" width="30" class="pt-2 pr-1">
                    </span>
                    <span class="pt-2 " id="refresh" @click="checkTallyStatus">
                      Tally
                    </span>
                </btn>
           </div>
        </div>
      </div>
    </div>
 
</template>
<script>
// import JetApplicationMark from "@/Jetstream/ApplicationMark.vue";
// import JetBanner from "@/Jetstream/Banner.vue";
// import JetDropdown from "@/Jetstream/Dropdown.vue";
// import JetDropdownLink from "@/Jetstream/DropdownLink.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
// import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";
// import {isElectron,checkTallyIsOpenElectron} from"@include/Pages/modules/UtilsJs/utils.js";
export default {
  props: {
    title: String,
  },
  components: {
    Head,
    // JetApplicationMark,
    // JetBanner,
    // JetDropdown,
    // JetDropdownLink,
    JetNavLink,
    // JetResponsiveNavLink,
    Link,
  },
  data() {
     return {
      showingNavigationDropdown: false,
      menuDef : new Object(),
      mOrder : new Object(),
      tally_open_status:'false',
    };
  },
  methods: {
    checkTallyStatus(){
      var _this = this;
     // checkTallyIsOpenElectron(_this);
    },
    switchToTeam(team) {
      this.$inertia.put(
        route("current-team.update"),
        {
          team_id: team.id,
        },
        {
          preserveState: false,
        }
      );
    },
    reload_in_electron(){
        //check if tally is open 
        if(isElectron()){
            window.api.send('refresh_page'); 
            window.api.receive("refresh_page-reply", (tally_response) => {
            })
        }
    },
    logout() {
      this.$inertia.post(route("logout"));
    },
    getMenuDef() {
      this.errors = {};
      axios
        .get("/menu/menuDef")
        .then((response) => {
          this.menuDef = response.data.menus
          console.log("menuDef",this.menuDef)
          this.mOrder = response.data.mOrder
        })
        .catch((error) => {
          if (error.response.status === 422) {
            console.log(error);
          //  this.errors = error.response.data.errors || {};
          }
          //alert("error");
        });
    },
     isContain:function(key,obj){
     return ( key in obj) ;
   },
  },
  computed:{
  
  },
mounted(){
    var _this = this;
    checkTallyIsOpenElectron(_this);
    this.getMenuDef();
}
};
</script>
<style>
.marg{
    /* padding-top: 77px;
    margin-left: 210px;
    z-index: 1;
    opacity: 1!important; */
}
/* .margin{
    position: fixed;
    width: 100%;
    z-index: 1;
    opacity: 1!important;
    background-color: white!important;;
} */
@media only screen and (min-width: 992px) {
 .frm{
    float: right;
    padding-left: 200px;
 }
}
@media only screen and (min-width: 1280px) {
 .frm{
    float: right;
    padding-left: 490px;
 }
}
@media only screen and (min-width: 1536px) {
 .frm{
    float: right;
    padding-left: 720px;
 }
}
/* @media only screen and (min-width: 768px) {
  .margin{
    width: 76%;
  }
} */
/* Large devices (laptops/desktops, 992px and up) */
/* @media only screen and (min-width: 992px) {
  .margin{
    width: 82%;
  }
}
@media only screen and (min-width: 1280px) {
  .margin{
    width: 86%;
  }
} */
.curve-stroke {
  color: #B5B5B5;
  border: 1px solid #F3F4F6;
  border-radius: 8px;
  font-size: 14px;
  padding: 0px 10px;
  text-decoration: none;
}
</style>